"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberWithZero = exports["default"] = exports.MINUTES_LIST = exports.HOURS_LIST = void 0;
var _react = require("react");
var _Picker = require("../Picker");
var _TimeInput = _interopRequireDefault(require("./TimeInput"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onChange", "value", "disabled", "onBlur", "mask", "format"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var numberWithZero = exports.numberWithZero = function numberWithZero(i) {
  return "".concat(i.toString().padStart(2, '0'));
};
var HOURS_LIST = exports.HOURS_LIST = new Array(24).fill(1).map(function (_v, i) {
  return numberWithZero(i);
});
var MINUTES_LIST = exports.MINUTES_LIST = new Array(4).fill(1).map(function (_v, i) {
  var minute = i * 15;
  return numberWithZero(minute);
});
var formatWithPattern = function formatWithPattern(numStr, format) {
  var hashCount = 0;
  var formattedNumberAry = format.split('');
  for (var i = 0, ln = format.length; i < ln; i++) {
    if (format[i] === '#') {
      formattedNumberAry[i] = numStr[hashCount] || '0';
      hashCount += 1;
    }
  }
  return formattedNumberAry.join('');
};
var getTimeList = function getTimeList(format) {
  return HOURS_LIST.map(function (hour) {
    return MINUTES_LIST.map(function (minutes) {
      var formatted = formatWithPattern("".concat(hour).concat(minutes), format);
      return {
        name: formatted,
        id: formatted
      };
    });
  }).flat();
};
var TimePicker = function TimePicker(_ref) {
  var _onChange = _ref.onChange,
    value = _ref.value,
    disabled = _ref.disabled,
    onBlur = _ref.onBlur,
    _ref$mask = _ref.mask,
    mask = _ref$mask === void 0 ? ['H', 'H', 'M', 'M'] : _ref$mask,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? '##:##' : _ref$format,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputRef = (0, _react.useRef)(null);
  var options = (0, _react.useMemo)(function () {
    return getTimeList(format);
  }, [format]);
  var minWidth;
  if (inputRef.current) {
    minWidth = inputRef.current.clientWidth;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Picker.Picker, {
    onClose: function onClose() {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    },
    button: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeInput["default"], _objectSpread({
      mask: mask,
      format: format,
      value: value,
      onChange: _onChange,
      inputProps: {
        ref: inputRef
      }
    }, props)),
    width: minWidth,
    withFilter: false,
    onChange: function onChange(values) {
      var _values$;
      var val = values === null || values === void 0 || (_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.id;
      _onChange({
        target: {
          value: val
        }
      }, val);
    },
    options: options,
    disabled: disabled,
    disableAutoFocus: true,
    disableEnforceFocus: true
  });
};
var _default = exports["default"] = TimePicker;